const trustItems = [
  { icon: "ri-shield-star-line", label: "Licensed & Insured", sub: "HVAC Professionals" },
  { icon: "ri-map-pin-2-line", label: "McKinney & Dallas Metro", sub: "Serving All Surrounding Areas" },
  { icon: "ri-star-fill", label: "5-Star Satisfaction", sub: "Verified Customer Reviews" },
  { icon: "ri-flashlight-line", label: "Same-Day Service", sub: "Emergency Availability" },
];

export default function TrustBar() {
  return (
    <section className="bg-[#020B14] border-b border-white/6">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-white/6">
          {trustItems.map((item) => (
            <div
              key={item.label}
              className="flex flex-col items-center text-center px-6 py-8"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-3 rounded-full bg-[#0EA5E9]/10">
                <i className={`${item.icon} text-[#7DD3FC] text-xl`}></i>
              </div>
              <div className="font-['Inter'] text-white font-semibold text-sm mb-0.5 whitespace-nowrap">{item.label}</div>
              <div className="font-['Inter'] text-white text-xs">{item.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
